<template>
    <el-button style="margin: 5px 0 5px 10px" type="autotype_Relevance" size="mini" @click.native="onRelevance()" :disabled="disabledRelevance">{{auto_str_Relevance}}</el-button>
</template>
<script>
import * as api from "@/api/etyma/etyma";
export default {
    props: {
        datas: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            disabledRelevance: false,
            auto_str_Relevance: "修改关联关系",
            autotype_Relevance: "success"
        };
    },
    mounted() {
        this.$bus.$on("busState" + this.datas.id, this.onRelevanceState);
    },
    beforeDestroy() {
        this.$bus.$off("busState" + this.datas.id);
    },
    methods: {
        onRelevanceState(str, disabled, auto_str, autotype, text) {
            this[disabled] = true;
            this.auto_fit_state(str, disabled, auto_str, autotype, text);
        },
        //修改关联关系进度
        auto_fit_state(str, disabled, auto_str, autotype, text) {
            api.get_progress_bar_detail({
                progress_key: str
            })
                .then(res => {
                    if (res.code === 0) {
                        if (res.data.tag == -1) {
                            this[disabled] = false;
                            this[autotype] = "danger";
                            this[auto_str] = `${text}（更新失败：${
                                res.message
                            }）`;
                        } else if (res.data.tag == 1) {
                            this[disabled] = false;
                            this[autotype] = "success";
                            this[auto_str] = `${text}（更新完成）`;
                        } else {
                            this[autotype] = "warning";
                            this[auto_str] = `${text}（完成进度：${
                                res.data.index
                            } / ${res.data.total}）`;
                            setTimeout(() => {
                                this.auto_fit_state(
                                    str,
                                    disabled,
                                    auto_str,
                                    autotype,
                                    text
                                );
                            }, 5000);
                        }
                    } else {
                        this[disabled] = false;
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.disabledbrand = false;
                });
        },
        onRelevance() {
            this.$emit("on-relevance", this.datas);
        }
    }
};
</script>
